module.exports = __webpack_public_path__ + "static/media/A1_Sports_DRAGON_GREEN.4c149486.png";